(function( $ ) {
    
    /******************************
     * Listgroup Plugin
     *
     * @returns {jQuery}
     */
    $.fn.listgroup = function() {

        var $listgroups = this;

        $listgroups.each(function(i, listgroup) {
            
            // 1.1 inside container?
            var containerEl = $(listgroup).closest('.tmp-container-row');
            if( $(containerEl).length > 0 ) {

                // 2.1 inside extra div?
                var containerInnerEl = $(containerEl).find('.tmp-container-extra-div');
                if( $(containerInnerEl).length > 0) {
                   $(containerInnerEl).addClass('listgroup-wrapper');
                   addListgroupClassToCol($(containerInnerEl));
                }
                // 2.2 not inside extra div
                else {
                    $(containerEl).children().wrapAll('<div class="listgroup-wrapper tmp-container-extra-div clearfix"></div>');
                    // transfer all classes except row|tmp-container-row to listgroup-wrapper
                    var classes = $(containerEl).attr('class').split(/\s+/);
                    $.each(classes, function( idx, classname ) {
                        if( classname != 'row' && classname != 'tmp-container-row' ) {
                            $(containerEl).removeClass(classname).find('.listgroup-wrapper').addClass(classname);
                        }
                    });
                    
                    $(containerEl).addClass('no-margin-left no-margin-right');
                    addListgroupClassToCol($(containerEl));
                }
            }
            // 1.2 not inside container?
            else {
                if( ! $(listgroup).parent().hasClass('listgroup-wrapper') ) {
                    $(listgroup).parent().children().wrapAll('<div class="listgroup-wrapper"></div>');
                }
                checkBgColor(listgroup);
            }
        });

        function addListgroupClassToCol(el) {
            $(el).find('.list-group').closest('.col').addClass('has-listgroup');
        }

        /**
         * Check for wrapper
         * @access private
         */
        // function checkWrapper(listgroup) {
        //     if( ! $(listgroup).parent().hasClass('listgroup-wrapper') ) {
        //         $(listgroup).parent().children().wrapAll('<div class="listgroup-wrapper"></div>');
        //     }
        // }

        /**
         * Check for background color
         * @access private
         */
        function checkBgColor( listgroup ) {
            var isBgColor = $(listgroup).closest('.col[class*="color-"]');

            if( $(isBgColor).length > 0 ) {
                var classes = $(isBgColor).attr('class').split(/\s+/);
                $.each(classes, function( idx, classname ) {
                    if( classname.startsWith('color-') || classname.startsWith('padding-') ) {
                       $(isBgColor).removeClass(classname).find('.listgroup-wrapper').addClass(classname);
                    }
                });
            }
        }

        return this;
    };

    $('.list-group').listgroup();
    
}( jQuery ));